export enum FaxStatus {
  Pending = 'PENDING',
  Sent = 'SENT',
  Failed = 'FAILED',
}

export interface Fax {
  id: string;
  claimID: string;
  createdBy: string;
  createdAt: string;
  status: FaxStatus;
  attachmentKey: string;
  recipient: string;
  siteID: string;
}
